import React, { useState } from "react";
import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Button,
  Chip,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Hidden from "../../../components/Hidden";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import utils from "../../../utils";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import AuthService from "../../../AuthService";
import { useSnackbar } from "notistack";
import { useTheme } from "@emotion/react";

const CompListaGrupo = ({
  grupos,
  handlePauseGrupo,
  handlePauseProduto,
  handleEditarGrupo,
  handleUpdateGrupo,
  duplicarProduto,
  ativos,
  setProdutoEdit,
  openCadProd,
  setOpenCadProd,
  setLoading,
}) => {
  const [expanded, setExpanded] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleChange = (panel) => (__, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const handleEditProduct = (product) => {
    if (!!product?.id && product?.id > 0) {
      setLoading(true);
      handleListProdutos(product.id)
        .then((produtoCompleto) => {
          setProdutoEdit(produtoCompleto);
          handleTogleOpenCadProd();
        })
        .catch((err) => {
          if (err.response === undefined) {
            enqueueSnackbar("Falha ao listar grupo", { variant: "error" });
          } else {
            err.response.json().then((elem) => {
              enqueueSnackbar("Falha ao listar grupo" + elem.errorMessage, {
                variant: "error",
              });
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleTogleOpenCadProd = () => {
    setOpenCadProd(!openCadProd);
  };

  const newProduct = (grupo) => {
    const produto = {
      descricao: "",
      nome: "",
      fichaTecnica: "",
      localImpressao: "CAIXA",
      pausado: false,
      localVenda: "TODOS",
      preco: 0.0,
      grupoProduto: { id: grupo.id },
      complementos: [],
      ativo: true,
      advertencia: "",
      codigoExterno: "",
    };

    setProdutoEdit(produto);
  };

  const handleAtivarGrupo = (grupo, event) => {
    event.stopPropagation();

    let service = new AuthService();
    let json = { id: grupo.id, ativo: true };

    service
      .put("/grupoProduto/changeOnly", json)
      .then((resp) => {
        let index = grupos.findIndex((el) => el.grupoProduto.id === resp.id);
        grupos[index].grupoProduto = resp;
        handleUpdateGrupo(grupos);
        enqueueSnackbar("Grupo ativado com sucesso", { variant: "success" });
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao ativar grupo", { variant: "error" });
      });
  };

  function handleListProdutos(produto) {
    let service = new AuthService();
    return service.get(`/produto/${produto}`);
  }

  return (
    <>
      {grupos.map((grupo) => (
        <React.Fragment key={grupo.grupoProduto.id}>
          {grupo.produtos.length === 0 && grupo.grupoProduto.id === -1
            ? null
            : grupo.grupoProduto.ativo === ativos && (
                <Box key={grupo.id} margin="0.25rem">
                  <Accordion
                    expanded={expanded === grupo.grupoProduto.id}
                    onChange={handleChange(grupo.grupoProduto.id)}
                    sx={{
                      border: "none",
                      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                    }}
                    slotProps={{ heading: { component: "h4" } }}
                    elevation={1}
                    disableGutters
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-label="Expandir"
                      aria-controls={grupo.grupoProduto.id + "-content"}
                    >
                      <Box display="flex" style={{ width: "100%" }}>
                        <Box flexGrow={1}>
                          <Typography variant="h6" color="primary">
                            {grupo.grupoProduto.descricao
                              ? grupo.grupoProduto.descricao?.toUpperCase()
                              : ""}
                          </Typography>
                        </Box>
                        <Box>
                          {grupo.grupoProduto.id !== -1 ? (
                            grupo.grupoProduto.ativo ? (
                              <Box
                                sx={{ display: "flex", flexDirection: "row" }}
                              >
                                {isTablet ? (
                                  <>
                                    <IconButton
                                      color={
                                        grupo.grupoProduto.pausado
                                          ? "secondary"
                                          : "primary"
                                      }
                                      onClick={(event) =>
                                        handlePauseGrupo(event, grupo)
                                      }
                                    >
                                      {grupo.grupoProduto.pausado ? (
                                        <PlayCircleOutlineIcon />
                                      ) : (
                                        <PauseCircleOutlineIcon />
                                      )}
                                    </IconButton>

                                    <IconButton
                                      onClick={(event) =>
                                        handleEditarGrupo(grupo, event)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  </>
                                ) : (
                                  <>
                                    <Button
                                      startIcon={
                                        grupo.grupoProduto.pausado ? (
                                          <PlayCircleOutlineIcon />
                                        ) : (
                                          <PauseCircleOutlineIcon />
                                        )
                                      }
                                      color={
                                        grupo.grupoProduto.pausado
                                          ? "secondary"
                                          : "primary"
                                      }
                                      onClick={(event) =>
                                        handlePauseGrupo(event, grupo)
                                      }
                                    >
                                      {grupo.grupoProduto.pausado
                                        ? "Iniciar vendas"
                                        : "Pausar vendas"}
                                    </Button>

                                    <Button
                                      startIcon={<EditIcon />}
                                      onClick={(event) =>
                                        handleEditarGrupo(grupo, event)
                                      }
                                    >
                                      Editar
                                    </Button>
                                  </>
                                )}
                              </Box>
                            ) : (
                              <Button
                                startIcon={<CheckCircleOutlineIcon />}
                                onClick={(event) =>
                                  handleAtivarGrupo(grupo.grupoProduto, event)
                                }
                              >
                                <Hidden mdDown>Ativar</Hidden>
                              </Button>
                            )
                          ) : null}
                        </Box>
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails
                      sx={{
                        padding: 0,
                        marginX: "2rem",
                      }}
                    >
                      <List style={{ width: "100%" }}>
                        {grupo.produtos.map((produto, index) => (
                          <React.Fragment key={produto.id}>
                            <ListItem>
                              <Box
                                sx={{
                                  display: "flex",
                                  width: "100%",
                                  flexDirection: isMobile ? "column" : "row",
                                  alignItems: isMobile
                                    ? "flex-start"
                                    : "center",
                                  justifyContent: "center",
                                }}
                              >
                                <ListItemText
                                  primary={
                                    <React.Fragment>
                                      <Typography
                                        color={"primary"}
                                        component="span"
                                        style={{
                                          fontWeight: "400",
                                          fontFamily: "Bebas Neue",
                                          textTransform: "capitalize",
                                          fontSize: "135%",
                                        }}
                                      >
                                        {produto.nome}
                                        {produto.promocaoAtiva ? (
                                          <Chip
                                            color="primary"
                                            size="small"
                                            label="promo"
                                            icon={<StarIcon />}
                                            style={{ marginLeft: "15px" }}
                                          />
                                        ) : null}
                                      </Typography>
                                    </React.Fragment>
                                  }
                                />
                                <Typography>
                                  {utils.formatNumber(produto.preco)}
                                </Typography>
                              </Box>
                              <IconButton
                                disabled={!grupo.grupoProduto.ativo}
                                color={
                                  produto.pausado ? "secondary" : "primary"
                                }
                                onClick={(event) =>
                                  handlePauseProduto(event, produto, grupo)
                                }
                              >
                                {produto.pausado ? (
                                  <PlayCircleOutlineIcon />
                                ) : (
                                  <PauseCircleOutlineIcon />
                                )}
                              </IconButton>

                              <IconButton
                                title="Editar produto"
                                disabled={!grupo.grupoProduto.ativo}
                                onClick={() => {
                                  handleEditProduct({ ...produto });
                                }}
                              >
                                <EditIcon />
                              </IconButton>

                              {grupo.grupoProduto.id !== -1 && (
                                <IconButton
                                  title="Criar uma cópia deste produto"
                                  onClick={() =>
                                    duplicarProduto(produto, grupo)
                                  }
                                >
                                  <FileCopyOutlinedIcon
                                    style={{ width: "20px" }}
                                  />
                                </IconButton>
                              )}
                            </ListItem>
                            {index < grupo.produtos.length - 1 && <Divider />}
                          </React.Fragment>
                        ))}
                      </List>
                    </AccordionDetails>

                    <AccordionActions sx={{ margin: "1rem" }}>
                      {grupo.grupoProduto.id !== -1 && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ maxWidth: "15rem" }}
                          fullWidth
                          disabled={!grupo.grupoProduto.ativo}
                          onClick={() => {
                            newProduct(grupo.grupoProduto);
                            handleTogleOpenCadProd();
                          }}
                        >
                          Novo Produto
                        </Button>
                      )}
                    </AccordionActions>
                  </Accordion>
                </Box>
              )}
        </React.Fragment>
      ))}
    </>
  );
};

export default CompListaGrupo;
